import { render, staticRenderFns } from "./modal-onboarding.vue?vue&type=template&id=70187413&"
import script from "./modal-onboarding.vue?vue&type=script&lang=js&"
export * from "./modal-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./modal-onboarding.vue?vue&type=style&index=0&id=70187413&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports